import React, { useEffect } from 'react';
import { useLocalSearchParams } from 'expo-router';
import { useDispatch } from 'react-redux';
import { setCurrentWeek } from '../../src/redux/mealPlanSlice';
import { AppDispatch } from '../../src/redux/store';
import TheWeeklyScreen from '../../src/components/weekly/TheWeeklyScreen';

/**
 * Home Screen - The Weekly
 *
 * The main screen of the app showing the magazine-style weekly meal planner.
 * Supports deep linking via ?week=YYYY-MM-DD query parameter (used by email CTA).
 * Supports swap deep link via ?swap=recipeId&day=N&meal=dinner (from email "Suggest another" links).
 */
const HomeScreen: React.FC = () => {
  const { week, swap, day, meal } = useLocalSearchParams<{
    week?: string;
    swap?: string;
    day?: string;
    meal?: string;
  }>();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (week && /^\d{4}-\d{2}-\d{2}$/.test(week)) {
      dispatch(setCurrentWeek(week));
    }
  }, [week, dispatch]);

  return <TheWeeklyScreen swapRecipeId={swap} swapDay={day ? parseInt(day, 10) : undefined} swapMealType={meal as 'breakfast' | 'lunch' | 'dinner' | undefined} />;
};

export default HomeScreen;
